<template>
  <div class="boxes videos vert-padded">
    <div v-if="(didNotUploadSecondAvatar || didNotUploadAvatar || lastUncompletedReportDay) && !hideUncompletedReportBar" class="report-reminder">
      <div class="inner" v-if="lastUncompletedReportDay">
        <Btn @click="() => hideUncompletedReportBar = true" class="close-btn">X</Btn>
        <p>{{isWeeklyReport(lastUncompletedReportDay)?
            t('You have an uncompleted weekly report for week {0}', Math.round(lastUncompletedReportDay/7)):
            t('You have an uncompleted report for day {0}', lastUncompletedReportDay)
          }}</p>
        <button @click="() => onQuizClick(lastUncompletedReportDay)">{{t('Fill now')}}</button>
      </div>
      <div class="inner" v-if="didNotUploadAvatar">
        <p>{{t('You should upload a progress image')}}</p>
        <button @click="onUploadAvatarClick">{{t('Upload now')}}</button>
      </div>
      <div class="inner" v-if="didNotUploadSecondAvatar">
        <p>{{t('You should upload a second progress image')}}</p>
        <button @click="onUploadSecondAvatarClick">{{t('Upload now')}}</button>
      </div>
    </div>
    <div v-for="(day, i) in shownDays" :key="'day'+i" :data-date="dateStr(dayDate(day))" :data-day="day">
<!--      <div v-if="isWeeklyReport(day) && day < daysInPlan" class="week-separator">{{t('Week {0}', Math.round(day/7)+1)}}</div>-->

      <Box v-if="dayHasQuiz(day) && showReport(day)" :subtitle="daysSince(day)" title="" :class="reportClass(day)" @click="() => onQuizClick(day)">
        <div class="flexy">
          <div class="report-icon">
            <img :src="reportIcon(day)" />
          </div>
          <div>
            <p class="report-tag">{{t('report')}}</p>
            <h3>{{boxTitle(day)}}</h3>
            <p v-if="reportIsCompleted(day)">{{t(isFinalReport(day)?'Review your final report':(isWeeklyReport(day) ?'Review your weekly report':'Review your daily report'))}}</p>
            <p v-else>
              <template v-if="isFinalReport(day)">{{t('Fill your final report')}}</template>
              <template v-else-if="isWeeklyReport(day)">{{t('Fill your weekly report')}}</template>
              <template v-else>{{t('Fill your daily report')}}</template>
            </p>
          </div>
        </div>
      </Box>
      <Box v-if="dayHasMeasurement(day)" :subtitle="daysSince(day)" title="" :class="reportClass(day)" @click="() => onMeasurementClick(day)">
        <div class="flexy">
          <div class="weighting-icon">
            <img :src="MeasurementIcon" />
          </div>
          <div>
            <p class="weighting-tag">{{t('measurement')}}</p>
            <h3>{{t('Measurement')}}</h3>
          </div>
        </div>
      </Box>
      <Box v-if="dayHasWeighting(day)" :subtitle="daysSince(day)" title="" :class="reportClass(day)" @click="() => onWeightingClick(day)">
        <div class="flexy">
          <div class="weighting-icon">
            <img :src="weightingIcon(day)" />
          </div>
          <div>
            <p class="weighting-tag">{{t('weighting')}}</p>
            <h3>{{t(isFirstWeighting(day)?'First Weighting':'Weighting')}}</h3>
            <p v-if="weightingIsCompleted(day)">{{t('Review your weighting')}}</p>
            <p v-else>{{t(isFirstWeighting(day)?'Fill your first weighting':'Fill your weighting')}}</p>
          </div>
        </div>
      </Box>
      <Box :title="parseDays(item.title)" :subtitle="daysSince(day)" v-for="(item, index) in dayItems(day)" :key="index">
        <p v-if="item.content" :class="'box-content' + (expandedContent[index]?' expanded':'')">{{item.content}}</p>
        <a href="javascript:void(0)" v-if="item.content && item.content.length > 100" @click="toggleExpandContent(index)">[{{t('Read All')}}]</a>
        <Vimeo v-if="item.media_path" :path="item.media_path" />
<!--        <button :class="watchedBtnClass(day)" @click="() => toggleWatchedVideo(day)" v-if="item.media_path && !item.date">-->
<!--            <img v-if="dayIsWatched(day)" :src="CheckIcon" />-->
<!--            {{t('Mark as watched')}}-->
<!--        </button>-->
      </Box>
    </div>
  </div>
</template>

<script>

import t from '@/lib/Locale';
import Box from "@/components/ui/widgets/Box.vue";
import Vimeo from "@/components/ui/widgets/Vimeo.vue";
import CheckIcon from '@/assets/icons/check.svg';
import WeightingIcon from '@/assets/icons/weighting.png';
import MeasurementIcon from '@/assets/icons/waist.png';
import ReportIcon from '@/assets/icons/report.png';
import {getQuizDays} from "@/lib/DailyQuizUtils";
import Btn from "@/components/ui/widgets/Btn.vue";

export default {
  name: "FeedItems",
  components: {Btn, Vimeo, Box},
  emits: ['uploadProfileImage'],
  data() {
    return {
      CheckIcon, MeasurementIcon,
      quizDays: [],
      windowHeight: 0,
      expandedContent: [],
      hideUncompletedReportBar: false
    }
  },
  async mounted() {
    this.quizDays = await getQuizDays(this.login)
    this.windowHeight = window.innerHeight
    window.addEventListener('scroll', this.setWindowHeight)

    const savedY = localStorage.getItem('feed-scroll-y')
    if (savedY) {
      window.scrollTo(0, savedY*1)
      for (let i = 1; i <= 40; i++) {
          setTimeout(() => window.scrollTo(0, savedY*1), 10*i)
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.setWindowHeight)
  },
  props : {
      login: {
        type: Object,
        default: () => { return {} }
      },
      todayReportHour: {
          type: String,
          default: '00:00'
      },

      showLearnedTasks : {
      type: Boolean,
      default: false
    },

    debug: {
      type: Boolean,
      default: false
    },

    daysInPlan: {
      type: Number,
      default: 0
    },
    items: {
      type: Array,
      default: () => []
    },
    datedItems: {
      type: Array,
      default: () => []
    },
    watchedVideos: {
        type: Array,
        default: () => []
    },
    planStartDate: {
      type: String,
      default: ''
    },
    completedReportDays: {
      type: Array,
      default: () => []
    },
    completedWeightings: {
      type: Array,
      default: () => []
    },
    completedMeasurements : {
        type: Array,
      default: () => []
    },
    planStartStats: {
      type: Object,
      default: () => {}
    },
    onQuizClick: {
      type: Function,
      default: () => {}
    },
    onWeightingClick: {
      type: Function,
      default: () => {}
    },
    onMeasurementClick: {
        type: Function,
      default: () => {}
    },
    onToggleWatchVideo: {
        type: Function,
        default: () => {}
    }
  },

  computed : {
    days() {
      let day = this.daysInPlan
      let d = []
      for (let i = day; i >= 0; i--) {
        d.push(i)
      }
      return d
    },

    didNotUploadAvatar() {
      if (!this.login || !this.login.meta) return false
      if (this.daysInPlan > 30) return false // don't bother reminding after 30 days
      return (!this.login.meta['avatar'])
    },
    didNotUploadSecondAvatar() {
      if (!this.login || !this.login.meta) return false
      if (this.daysInPlan < 91) return false
      return (this.login.meta['avatar'] && !this.login.meta['avatar2'])
    },

    lastUncompletedReportDay() {
      for (let i = this.daysInPlan; i >= 0; i--) {
        if (!this.completedReportDays.includes(i) && this.dayHasQuiz(i) && this.showReport(i)) return i
      }
      return null
    },

    shownDays() {
      return this.days
      // let totalHeight = 0, d = []
      // const elHeight = window.innerWidth > 798 ?
      //     (window.innerWidth > 1440 ? 755 : 650)
      //     : 570, days = this.days
      // for (let i = 0; i < days.length; i++) {
      //   if (days[i] < 82) totalHeight += elHeight
      //   if (totalHeight < this.windowHeight + 3000) {
      //     d.push(days[i])
      //   }
      //   else {
      //     break
      //   }
      // }
      // return d
    }
  },


  methods: {
    t,

    onUploadAvatarClick() {
      console.log("ick")
      this.$emit('uploadProfileImage')
    },

    onUploadSecondAvatarClick(){
      this.$emit('uploadSecondProfileImage')
    },

    boxTitle(day) {
      if (this.isFinalReport(day)) return t('Final Report')
      return this.isWeeklyReport(day)?t('Weekly Report: week {0}', Math.round(day/7)):t('Daily Report: week {0}, day {1}', this.planWeek(day), this.planWeekday(day))
    },

    watchedBtnClass(day) {
        return 'btn watched-btn ' + (this.dayIsWatched(day) ? 'watched' : 'not-watched')
    },

    dayIsWatched(day) {
        return this.watchedVideos.includes(day)
    },

    showReport(day) {
      if (day < this.daysInPlan) return true
      else {
        const time = this.todayReportHour.split(':')
        const now = new Date()
        const reportTime = new Date()
        reportTime.setHours(time[0])
        reportTime.setMinutes(time[1])
        console.log("Should show report?", { now, reportTime, ok: now >= reportTime })
        return now >= reportTime
      }
    },

    toggleWatchedVideo(day) {
        this.onToggleWatchVideo(day)
    },

    reportIcon() {
      return ReportIcon
        // if (this.reportIsCompleted(day)) {
        //     return this.isFinalReport(day)? FinalReportCompleteIcon : (this.isWeeklyReport(day) ? WeeklyReportCompleteIcon : DailyReportCompleteIcon)
        // }
        // return this.isFinalReport(day) ? FinalReportIcon : (this.isWeeklyReport(day) ? WeeklyReportIcon : DailyReportIcon)
    },

    weightingIcon() {
        return WeightingIcon
    },

    setWindowHeight() {
      let y = window.scrollY, h = window.innerHeight
      if (y + h >= this.windowHeight) this.windowHeight = y + h

      // save y to local storage
      localStorage.setItem('feed-scroll-y', y)
    },

    daysSince(day) {
      let d = new Date(this.planStartDate)
      d.setDate(d.getDate() + (day - 1))
        let cur = new Date(this.planStartDate)
        cur.setDate(cur.getDate() + (this.daysInPlan - 1))
      let diff = Math.round((cur - d) / (1000 * 60 * 60 * 24))

      if (isNaN(diff)) return t('Today')

      if (diff === 0) return t('Today')
      if (diff === 1) return t('Yesterday')
      if (diff === 2) return t('2 days ago')
      if (diff < 7) return t('{0} days ago', diff)
      if (diff < 14) return t('Last week')
      return t('{0} weeks ago', Math.round(diff / 7))
    },

    dateStr(date) {
      date = new Date(date);
      let s = date.getFullYear() + '-'
      if (date.getMonth() < 10) s += '0';
      s += (date.getMonth()+1) + '-'
      if (date.getDate() < 10) s += '0';
      s += date.getDate();

      return s;
    },

    dayDate(day) {
      let d = new Date(this.planStartDate)
      d.setDate(d.getDate() + (day - 1))
      return d
    },

    dayItems(day) {
      let items = this.items.filter(it => it.day === day)
      let datedItems = this.datedItems.filter(it => this.dateStr(this.dayDate(day)) === this.dateStr(it.fixed_date.replace(/ /g,"T")))
      return items.concat(datedItems)
    },

    toggleExpandContent(index) {
      this.$set(this.expandedContent, index, !this.expandedContent[index])
    },

    isFirstWeighting(day) {
      const d = day * 1
      return d === 1
    },

    isFinalReport(day) {
      return day === 81
    },

    isWeeklyReport(day) {
      return day % 7 === 0 || day === 6
    },

    reportClass(day) {
      if (this.completedReportDays.includes(day)) return 'report completed';
      return 'report';
    },

    reportIsCompleted(day) {
      return this.completedReportDays.includes(day);
    },

    weightingIsCompleted(day) {
      if (day*1 === 1) {
        return this.planStartStats && this.planStartStats.weight && this.planStartStats.height && this.planStartStats.chest && this.planStartStats.waist && this.planStartStats.hips
      }
      return this.completedWeightings.includes(day);
    },

    measurementIsCompleted(day) {
        return this.completedMeasurements.includes(day);
    },

    dayHasQuiz(day) {
      return this.quizDays.includes(day) && day > 0;
    },

    dayHasMeasurement(day) {
      const measurementDays = [29,58,82];
      return measurementDays.includes(day);
    },

    dayHasWeighting(day) {
      const weightingDays = [1, 9, 16, 23, 30, 37, 44, 51, 58, 65, 72, 79];
      return weightingDays.includes(day);
    },

      planWeekday(planDay) {
        let weekday = planDay % 7
        if (weekday === 0) weekday = 7
        let days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
        return t(days[weekday - 1])
    },

    planWeek(planDay) {
        return Math.floor(planDay / 7) + 1
    },

    parseDays(str) {
      let day = str.match(/\d+:/g)
      if (day) {
        day = day[0].replace(':', '')
        day = t("Week {0}, Day {1}", this.planWeek(day), this.planWeekday(day))
        str = day +' - '+ str.substring(str.indexOf(':') + 1)
      }
      return str
    }
  }
}
</script>
